<template>
  <div class="container-fixed">
    <h1>DetailBox test</h1>
    <VDetailBoxWrapper>
      <VDetailBox>
        <template #headline>
          IS NOT VISIBLE!
        </template>
        <template #default>
          <span v-if="false">IS NOT VISIBLE!</span>
        </template>
      </VDetailBox>
    </VDetailBoxWrapper>

    <section style="background-color: transparent">
      <VDetailBoxWrapper>
        <VDetailBox>
          <template #headline>
            Headline
          </template>
          <template #default> hallo <b>welt</b>! </template>
        </VDetailBox>

        <VDetailBox>
          <template #headline>
            Headline (with VEmpty)
          </template>
          <template #default>
            <VEmpty />
          </template>
        </VDetailBox>

        <VDetailBox>
          <template #headline>
            Headline (SHOULD NOT BE VISIBLE)
          </template>
        </VDetailBox>

        <VDetailBox>
          <template #headline>
            Headline (SHOULD NOT BE VISIBLE)
          </template>
          <template #default>
            <span v-if="false">(SHOULD NOT BE VISIBLE)</span>
            <!-- comment -->
          </template>
        </VDetailBox>

        <VDetailBox>
          <span v-if="false">(SHOULD NOT BE VISIBLE)</span>
        </VDetailBox>

        <VDetailBox>
          <template #headline>
            Headline (SHOULD NOT BE VISIBLE)
          </template>
          <template #default>
            <span v-if="false">(SHOULD NOT BE VISIBLE)</span>
          </template>
        </VDetailBox>

        <VDetailBox mandatory>
          <template #headline>
            Headline (mandatory)
          </template>
        </VDetailBox>

        <VDetailBox positive>
          hallo!
        </VDetailBox>

        <VDetailBox negative>
          hallo!
        </VDetailBox>

        <VDetailBox label="label">
          with label
        </VDetailBox>

        <VDetailBox :width="3">
          hallo!
        </VDetailBox>

        <VDetailBox :width="2">
          hallo!
        </VDetailBox>

        <VDetailBox headline="headline property">
          <template #default>hallo! <br />lorem ispum<br />lorem ispum<br />lorem ispum<br />lorem ispum<br />lorem ispum<br />ende</template>
          <template #grayed>
            GRAYED AREA!
          </template>
        </VDetailBox>
      </VDetailBoxWrapper>

      <VDetailBoxWrapper gray tag="ul">
        <VDetailBox icon="information" tag="li">
          as description list
        </VDetailBox>
      </VDetailBoxWrapper>

      <VDetailBoxWrapper expanded>
        <VDetailBox>
          hallo!
        </VDetailBox>

        <VDetailBox :width="3">
          hallo!
        </VDetailBox>

        <VDetailBox>
          <div ref="test" tabindex="-1">hallo!</div>
        </VDetailBox>

        <VDetailBox :width="2">
          hallo!
        </VDetailBox>

        <VDetailBox :width="3" table>
          no spacing
        </VDetailBox>
      </VDetailBoxWrapper>
    </section>

    <hr />

    <h1>AutoRows test</h1>

    <VAutoRows>
      <b>one</b>
      <b>two</b>
      <b>three</b>
      <b>four</b>
      <b>five</b>
    </VAutoRows>

    <hr />

    <h1>Section test</h1>

    <VSection :level="1"> </VSection>

    <VSection :level="2">
      <b v-if="false">test</b>
    </VSection>

    <VSection mandatory :level="3"> </VSection>

    <VSection>
      <span>test1</span>
    </VSection>

    <VSection label="test">
      <span>test2 with label</span>
    </VSection>

    <VSection label="common.test_html">
      <span>test3 with html-label</span>
    </VSection>

    <VSection label="common.test_html" cluster>
      <span>test4 cluster</span>
    </VSection>

    <VSection label="common.test_html" large>
      <span>test5 large</span>
    </VSection>

    <VSection label="common.test_html" group>
      <span>test6 group</span>
    </VSection>

    <VSection label="common.test_html" :collapsed.sync="isCollapsed">
      <span>test7 collapsed false (clickable)</span>
    </VSection>

    <VSection label="common.test_html" :collapsed="true">
      <span>test8 collapsed true</span>
    </VSection>

    <VSection label="common.test_html" hl-style="h1">
      <span>test9 hl-style</span>
    </VSection>

    <VSection label="common.test_html" h1 cluster>
      <span>test10 h1 + cluster</span>
    </VSection>

    <VSection label="common.test_html" h1>
      <span>test11 h1</span>
    </VSection>
    <VSection label="common.test_html" h2>
      <span>test12 h2</span>
    </VSection>
    <VSection label="common.test_html" h3>
      <span>test13 h3</span>
    </VSection>
    <VSection label="common.test_html" h4>
      <span>test14 h4</span>
    </VSection>
    <VSection label="common.test_html" h5>
      <span>test15 h5</span>
    </VSection>
    <VSection label="common.test_html" h6>
      <span>test16 h6</span>
    </VSection>

    <VSection label="common.test_html" :level="1">
      <span>test17 level 1</span>
    </VSection>

    <VSection label="common.test_html" :level="2">
      <span>test18 level 2</span>
    </VSection>

    <VSection label="common.test_html" :level="3">
      <span>test19 level 3</span>
    </VSection>

    <VSection label="common.test_html" :level="4">
      <span>test20 level 4</span>
    </VSection>
  </div>
</template>

<script>
import VSection from '@/components/Section';
import VEmpty from '@/components/Empty';
import VDetailBoxWrapper from '@/components/UI/DetailBox/Wrapper';
import VDetailBox from '@/components/UI/DetailBox';
import VAutoRows from '@/components/AutoRows';

export default {
  name: 'DetailBoxTest',

  components: {
    VSection,
    VEmpty,
    VDetailBoxWrapper,
    VDetailBox,
    VAutoRows,
  },

  data() {
    return {
      isCollapsed: false,
    };
  },
};
</script>

<style scoped>
section {
  padding: 12px;
  margin: 24px 0;
  background-color: #eeefef;
}

h2 {
  padding: 0 0 24px 0;
  margin: 0;
}
</style>
